
import { get, post } from '../utils/http'

export const typeahead = (query) => (get('SEARCH_TYPE_AHEAD', `/admin/typeahead?q=${encodeURIComponent(query)}`, 'payload', { query }))

export const selectTypeahead = (value) => ({ type: 'SEARCH_TYPE_AHEAD_SELECT', payload: value })

export const clearSelected = () => ({ type: 'SEARCH_SELECTED_CLEAR' })

export const doSearch = (query) => (get('SEARCH_RESULT', `/searchhits?q=${encodeURIComponent(query)}&&exactMatch=false&days=-1&matchAllWords=one&excludeWords=&showHidden=true`, 'payload', { query }))


// WEBPACK FOOTER //
// ./src/search/searchActions.js